import * as firebase from 'firebase/app';
import 'firebase/auth';

import config from '../config/config';

firebase.initializeApp(config);

export function signIn() {
  const provider = new firebase.auth.GoogleAuthProvider();
  return firebase.auth().signInWithPopup(provider).then((result) => {
    // console.log(result, result);
    const data = { idToken: result.user.ya };
    return data;
  });
}

// export function getNewFirebaseIdToken() {
//   console.log('######generateToken');
//   try {
//     return firebase.auth().currentUser.getIdToken(true).then((idToken) => {
//       console.log('*****idToken: ', idToken);
//       return idToken;
//     }).catch((err) => { console.log('%%%%%%', err); });
//   } catch (err) {
//     console.log('####idTokenGenerationError:', err);
//     return Promise.resolve();
//   }
// }

export function setToken(token) {
  if (token) {
    localStorage.setItem('token', token);
    localStorage.setItem('tokenGenerationTime', new Date());
  }
}

export function generateAndSetNewToken() {
  return new Promise((resolve) => {
    return firebase.auth().onAuthStateChanged(async (user) => {
      return user && user.getIdToken(true).then(async (idToken) => {
        setToken(idToken);
        console.log('NEW_TOKEN_CREATED_SUCCESSFULLY');
        return resolve();
      });
    });
  });
}
